export default "__VITE_ASSET__BzzZkNAj__"